<template>
  <div class="el-col-24">
    <input class="file" type="file" style="display:none" id="file" ref="input" @change="doUpload">
    <quill-editor
      v-model="myContent"
      ref="myQuillEditor"
      :options="editorOption"
      @ready="onEditorReady($event)"
      @change="onEditorChange($event)">
    </quill-editor>
  </div>
</template>

<script>
import { uploadItemImg } from '../../api/public/quill'
import { QuillWatch } from 'quill-image-extend-module'
export default {
  // 父组件传过来的初始值-编辑时用
  props: ['content'],
  mounted () {
  },
  watch: {
    content () {
      this.myContent = this.content
    }
  },
  data () {
    return {
      myContent: this.content,
      editorOption: {
        // some quill options
        placeholder: '请输入正文',
        modules: {
          ImageExtend: {
            loading: true,
            name: 'imgFile',
            action: this.$config.api_url + '/fileUpload/imgUpload',
            headers: (xhr) => {
            },
            response: (res) => {
              return res.resultData.fileUrl.split('?Expires=')[0]
            }
          },
          imageResize: {},
          toolbar: {
            container: [
              ['bold', 'italic', 'underline'], // toggled buttons
              ['image'],
              [{'header': 1}, {'header': 2}], // custom button values
              [{'list': 'ordered'}, {'list': 'bullet'}],
              [{'indent': '-1'}, {'indent': '+1'}], // outdent/indent
              [{ size: ['14px', '16px', '18px', '20px', '30px', '32px'] }],
              [{'color': []}, {'background': []}], // dropdown with defaults from theme
              [{'align': []}],
              ['link']
            ],
            handlers: {
              'image': function (value) {
                if (value) {
                  QuillWatch.emit(this.quill.id)
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {
    doUpload () {
      let file = document.getElementById('file').files[0]
      let formdata = new FormData()// 创建form对象
      formdata.append('imgFile', file, file.name)
      let length = this.quill.getSelection(true).index
      uploadItemImg(formdata).then(res => {
        if (res.data.resultCode === 0) {
          this.quill.insertEmbed(length, 'image', res.data.resultData.fileUrl.split('?Expires=')[0])
          document.getElementById('file').value = ''
        } else {
          this.$message.error(res.data.resultMessage)
        }
      })
    },
    imgHandler (handle) {
      this.quill = handle.quill
      var inputfile = document.getElementById('file')
      inputfile.click()
    },
    onEditorReady (editor) {
      this.initPic(editor)
    },
    onEditorChange ({ editor, html, text }) {
      this.$emit('getQuillContent', html)
      this.$emit('update:content', html)
      this.myContent = html
    },
    initPic () {
      setTimeout(() => {
        const quill = this.$refs.myQuillEditor.quill
        this.$forceUpdate()
        quill.root.addEventListener(
          'paste', (evt) => {
            if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
              evt.preventDefault(); // 必须阻止默认行为，会粘贴两次，并且图片的base64格式
              [].forEach.call(evt.clipboardData.files, (file) => {
                if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
                  return
                }
                let formdata = new FormData()// 创建form对象
                formdata.append('imgFile', file, file.name)
                uploadItemImg(formdata).then(res => {
                  if (res.data.resultCode === 0) {
                    const length = quill.getSelection().index
                    quill.insertEmbed(length, 'image', res.data.resultData.fileUrl.split('?Expires=')[0])
                  } else {
                    this.$message.error(res.data.resultMessage)
                  }
                })
              })
            }
          }, false
        )
      }, 10)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ql-editor{
  min-height: 250px;
  max-height: 700px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Public/Quill.vue